// extracted by mini-css-extract-plugin
export default {"root":"k2JEjACFbq"};